"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const slider = document.querySelector(".o-hero-header__blog .splide");

        if (!slider) return;

        const splide = new Splide(slider, {
            type: "loop",
            perPage: 1,
            gap: "16px",
            arrows: true,
            pagination: false,
            perMove: 1,
        });
        const bar = splide.root.querySelector(".my-slider-progress-bar");
        console.log(bar);
        splide.on("mounted move", function () {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min((splide.index + 1) / end, 1);
            bar.style.width = String(100 * rate) + "%";
        });

        splide.mount();
    });
}
